import React, { createContext, useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const HeaderVisibilityContext = createContext<boolean>(true);

export const useHeaderVisibility = () => useContext(HeaderVisibilityContext);

export const HeaderVisibilityProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const location = useLocation();
  const isVisible = !location.pathname.includes('/create/templates');

  useEffect(() => {
    document.body.classList.toggle('hide-header', !isVisible);
  }, [isVisible]);

  return (
    <HeaderVisibilityContext.Provider value={isVisible}>
      {children}
    </HeaderVisibilityContext.Provider>
  );
};
